import { ToggleButton } from '@mui/material';
import React, { useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { FormFieldset } from 'src/shared/components/form/formFieldset';
import { StyledToggleButtonGroup } from 'src/shared/components/organisms/styledToggleButtonGroup';

export interface MembershipTypeItem {
  label: string;
  key: string;
}

export const membershipTypes: MembershipTypeItem[] = [
  {
    label: 'member:memberAdvancedSearch.isMainMember',
    key: 'isMainMember',
  },
  {
    label: 'member:memberAdvancedSearch.isFamilyMember',
    key: 'isFamilyMember',
  },
];

export const MemberAdvancedSearchMembership = () => {
  const { setValue, watch } = useFormContext();
  const { t } = useTranslation(['member']);

  const [selectedMembershipType, setSelectedMembershipType] = useState<string>('');

  const handleChange = (event: React.MouseEvent<HTMLElement>, newMembershipType: string) => {
    setSelectedMembershipType(newMembershipType);
    setValue('isMainMember', newMembershipType === 'isMainMember' ? 'true' : '');
    setValue('isFamilyMember', newMembershipType === 'isFamilyMember' ? 'true' : '');
  };

  const isMainMember = watch('isMainMember');
  const isFamilyMember = watch('isFamilyMember');

  React.useEffect(() => {
    if (isMainMember) setSelectedMembershipType('isMainMember');
    if (isFamilyMember) setSelectedMembershipType('isFamilyMember');
    if (!isMainMember && !isFamilyMember) setSelectedMembershipType('');
  }, [isMainMember, isFamilyMember]);

  return (
    <FormFieldset legend={t('member:memberAdvancedSearch.membershipType')} inflowLegend noPadding>
      <StyledToggleButtonGroup value={selectedMembershipType} onChange={handleChange} exclusive color='primary' size='small'>
        {membershipTypes.map((x) => (
          <ToggleButton value={x.key} key={x.key}>
            {t(x.label)}
          </ToggleButton>
        ))}
      </StyledToggleButtonGroup>
    </FormFieldset>
  );
};
